<template>
 <div
    class="container inter-sans font-jakarta p-3.5 sm:px-4 md:px-8 lg:px-16 xl:px-16 mx-auto my-2"
  >
  <NavbarPartial />
  <MainPartial />
   </div>
</template>
<script>
import NavbarPartial from './components/NavbarPartial.vue'
import MainPartial from './components/MainPartial.vue'
export default {
  components: {
    NavbarPartial,
    MainPartial
  }
}
</script>
